import { render } from "./risk-supply.vue?vue&type=template&id=6574712f&scoped=true"
import script from "./risk-supply.vue?vue&type=script&lang=js"
export * from "./risk-supply.vue?vue&type=script&lang=js"

import "./risk-supply.vue?vue&type=style&index=0&id=6574712f&lang=less&scoped=true"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6574712f"]])

export default __exports__